<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        立项评审
      </el-breadcrumb-item>
      <el-breadcrumb-item>课题评审</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div v-for="item in projcetDistribute" :key="item.direction">
        <h3>课题类别：{{ item.category }}</h3>
        <h3>课题方向： {{ item.direction }}</h3>
        <!-- 申报书列表 -->
        <el-table :data="item.data" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="pname" label="名称" width="380"></el-table-column>
          <el-table-column prop="leader_name" label="作者" width="180"></el-table-column>
          <el-table-column label="查看" width="80">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                @click="showInfoForm(scope.row)">
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="评审" width="150">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" @click="assessButton(scope.row)">评审
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <div style="margin-bottom: 20px">
        <div class="div-file">
          <el-table :data="fileList" style="width: 551px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getPdfCode(scope.row)"></el-button>
                <!-- <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-button type="success" plain @click.prevent="ButtonShowPng()">查看图片</el-button>
        <el-button type="success" plain @click.prevent="ButtonDownOriginFile()">下载原文件</el-button> -->
      </div>
      <el-row>
        <el-col :span="24">
          <div class="header-edit">申报书详情</div>
        </el-col>
      </el-row>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题方向：</span>
          <span>{{ editForm.category_direction }}</span>
          <span> 课题名称：</span>
          <el-input :disabled="true" v-model="editForm.name"></el-input>
        </el-col>
      </el-card>
      <!-- 项目主持人情况 -->
      <el-card class="el-card-leader">
        <div class="div-leader">
          <span>项目主持人情况</span>
        </div>
        <el-table :data="projectLeader" border style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="username" label="姓名" width="80"></el-table-column>
          <el-table-column prop="gender" label="性别" width="60"></el-table-column>
          <el-table-column prop="national" label="民族" width="80"></el-table-column>
          <el-table-column prop="birth" label="出生年月" width="80"></el-table-column>
          <el-table-column prop="duty" label="行政职务" width="120"></el-table-column>
          <el-table-column prop="title" label="专业职称" width="120"></el-table-column>
          <el-table-column prop="major" label="研究专长" width="140"></el-table-column>
          <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
          <el-table-column prop="degree" label="最后学位" width="80"></el-table-column>
          <el-table-column prop="province" label="所在省(自治区、直辖市)" width="180"></el-table-column>
        </el-table>
        <el-table :data="projectLeader" border style="width: 1021px; margin-top: -1px"
          :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="organization" label="工作单位" width="280"></el-table-column>
          <el-table-column prop="tel" label="联系电话" width="160"></el-table-column>
          <el-table-column prop="email" label="E-mail" width="200"></el-table-column>
          <el-table-column prop="addr" label="通讯地址" width="280"></el-table-column>
          <el-table-column prop="zipcode" label="邮政编码" width="100"></el-table-column>
        </el-table>
      </el-card>
      <!-- 主要参加者情况 -->
      <el-card>
        <div class="member">
          <span> 主要参加者情况</span>
        </div>
        <el-table :data="projectMember" style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="姓名" width="80"></el-table-column>
          <el-table-column prop="organization" label="单位" width="280"></el-table-column>
          <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
          <el-table-column prop="major" label="所学专业" width="160"></el-table-column>
          <el-table-column prop="duty" label="技术职务" width="120"></el-table-column>
          <el-table-column prop="division" label="研究分工" width="200"></el-table-column>
        </el-table>
      </el-card>
      <!-- 预期成果形式 -->
      <el-card>
        <el-row class="el-row-detail">
          <el-col :span="8"><span> 预期成果形式：</span>
            <el-input :disabled="true" v-model="editForm.result_type"></el-input>
          </el-col>
          <el-col :span="8"><span> 字数：</span>
            <el-input :disabled="true" v-model="editForm.total_words"></el-input>
          </el-col>
          <el-col :span="8"><span> 预计完成时间：</span>
            <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
          </el-col>
        </el-row>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div>课题研究计划</div>
        <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor"></quill-editor>
        <div style="margin-top: 10px;">课题申报情况及课题研究基础</div>
        <quill-editor :disabled="true" v-model="editForm.leader_introduction" :options="editorOption"
          class="editor"></quill-editor>
        <!-- 文件列表 -->
      </el-card>
      <!-- 预算 -->
      <el-card>
        <h3>课题预算</h3>
        <div class="div-budget">
          <div>
            <table>
              <tr>
                <td>序号</td>
                <td>预算科目名称</td>
                <td>预算金额（万元）</td>
                <td>测算依据（另附页说明）</td>
              </tr>
              <tr>
                <td>1</td>
                <td>经费总额</td>
                <td>
                  <el-input v-model="budget.f1"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s1"></el-input>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>一、直接费用</td>
                <td>
                  <el-input v-model="budget.f2"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s2"></el-input>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>1.设备费</td>
                <td>
                  <el-input v-model="budget.f3"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s3"></el-input>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>（1）购置设备费</td>
                <td>
                  <el-input v-model="budget.f4"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s4"></el-input>
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>（2）试制设备费</td>
                <td>
                  <el-input v-model="budget.f5"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s5"></el-input>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>（3）设备改造与租赁费</td>
                <td>
                  <el-input v-model="budget.f6"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s6"></el-input>
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>2.材料费</td>
                <td>
                  <el-input v-model="budget.f7"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s7"></el-input>
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>3.测试化验加工费</td>
                <td>
                  <el-input v-model="budget.f8"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s8"></el-input>
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>4.差旅费</td>
                <td>
                  <el-input v-model="budget.f9"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s9"></el-input>
                </td>
              </tr>
              <tr>
                <td>10</td>
                <td>其中：市内交通费</td>
                <td>
                  <el-input v-model="budget.f10"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s10"></el-input>
                </td>
              </tr>
              <tr>
                <td>11</td>
                <td>5.会议费</td>
                <td>
                  <el-input v-model="budget.f11"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s11"></el-input>
                </td>
              </tr>
              <tr>
                <td>12</td>
                <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
                <td>
                  <el-input v-model="budget.f12"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s12"></el-input>
                </td>
              </tr>
              <tr>
                <td>13</td>
                <td>7.劳务费</td>
                <td>
                  <el-input v-model="budget.f13"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s13"></el-input>
                </td>
              </tr>
              <tr>
                <td>14</td>
                <td>8.专家咨询费</td>
                <td>
                  <el-input v-model="budget.f14"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s14"></el-input>
                </td>
              </tr>
              <tr>
                <td>15</td>
                <td>二、间接经费（不得超过课题经费总额的10%）</td>
                <td>
                  <el-input v-model="budget.f15"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s15"></el-input>
                </td>
              </tr>
              <tr>
                <td>16</td>
                <td>1.管理费用</td>
                <td>
                  <el-input v-model="budget.f16"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s16"></el-input>
                </td>
              </tr>
              <tr>
                <td>17</td>
                <td>2.其他具体说明</td>
                <td>
                  <el-input v-model="budget.f17"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s17"></el-input>
                </td>
              </tr>
            </table>

            <div style="margin-top: 20px;">
              <span style="font-size: 20px;">测算依据说明:</span>
            </div>
            <quill-editor v-model="budget.reason" :options="editorOption" class="editor"></quill-editor>
          </div>
        </div>
      </el-card>
    </el-card>

    <!-- 11-26取消 申报书查看对话框，显示申报书图片 -->
    <!-- <el-dialog title="申报书详情" :visible.sync="infoDialogVisible">
      <div v-show="projectInfoPngIsNull">请等待详情页面加载……</div>
      <div v-for="item in projectInfoPng" :key="item.id">
        <img :src="item.content" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoDialogHide()">确定</el-button>
      </div>
    </el-dialog> -->

    <!-- 评审对话框 -->
    <!-- <el-dialog title="课题评审" :visible.sync="assessDialogVisible">
      <h3>课题方向：{{ projectAssess.category_direction }}</h3>
      <h3>课题名称：{{ projectAssess.pname }}</h3>
      <h3>作者：{{ projectAssess.leader_name }}</h3>
      <h3>作者单位：{{ projectAssess.organization }}</h3>
      <el-card>
        <div class="divScore">
          一、专家对科研项目的基本评定（请点击相应的评分）：
        </div>
        <el-table :data="assessScore">
          <el-table-column prop="name" label="评分项"></el-table-column>
          <el-table-column prop="score" label="评分" width="500">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.score" v-for="item in scope.row.scores" :key="item.score">
                <el-radio :label="item.score">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card>
        <div class="divSuggestion">二、专家对该项目的意见及建议</div>
        <el-input type="textarea" v-model="assessSuggestion"></el-input>
      </el-card>
      <el-card>
        <div class="divAgree">三、是否同意该项目立项</div>
        <el-radio v-model="assessAgree" label="同意">是</el-radio>
        <el-radio v-model="assessAgree" label="不同意">否</el-radio>
      </el-card>
      <el-card>
        <div class="divSuggestion">四、专家对该项目经费建议(单位：万元)</div>
        <el-input v-model="assessFunds"></el-input>
      </el-card>
      <div style="margin-top: 20px;">
        <span>请输入签名密码 </span>
        <el-input style="width: 200px;" v-model="password" show-password></el-input>
      </div>
      <el-button type="primary" @click="assess()">提交</el-button>
    </el-dialog> -->

    <!-- 20230521 固定位置在右侧，方便专家操作 -->
    <el-card class="card-assess" v-show="assessDialogVisible">
      <div>
        <el-button @click="closeCard" type="text" style="float: right;">关闭</el-button>
      </div>
      <!-- <h3>课题方向：{{ projectAssess.category_direction }}</h3> -->
      <h4>课题名称：{{ projectAssess.pname }}</h4>
      <h4>作者：{{ projectAssess.leader_name }}</h4>
      <!-- <h3>作者单位：{{ projectAssess.organization }}</h3> -->
      <el-card>
        <div class="divScore">
          一、专家对科研项目的基本评定（请点击相应的评分）：
        </div>
        <el-table :data="assessScore">
          <el-table-column prop="name" label="评分项"></el-table-column>
          <el-table-column prop="score" label="评分" width="400">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.score" v-for="item in scope.row.scores" :key="item.score">
                <el-radio :label="item.score">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card>
        <div class="divSuggestion">二、专家对该项目的意见及建议</div>
        <quill-editor v-model="assessSuggestion" :options="editorOption" class="editor">
        </quill-editor>
        <!-- <el-input type="textarea" v-model="assessSuggestion"></el-input> -->
      </el-card>
      <el-card>
        <div class="divAgree">三、是否同意该项目立项</div>
        <el-radio v-model="assessAgree" label="同意">是</el-radio>
        <el-radio v-model="assessAgree" label="不同意">否</el-radio>
      </el-card>
      <el-card>
        <div class="divSuggestion">四、专家对该项目经费建议(单位：万元)</div>
        <el-input v-model="assessFunds" :disabled="assessAgree == '不同意'"></el-input>
      </el-card>
      <div style="margin-top: 20px;">
        <span>请输入签名密码 </span>
        <el-input style="width: 200px;" v-model="password" show-password></el-input>
      </div>
      <el-button type="primary" @click="save()">保存</el-button>
      <el-button type="primary" @click="assess()">提交</el-button>
    </el-card>

    <!-- pdf查看 -->
    <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
      <div class="onlineHelp cg-box">
        <div class="tools">
          <el-button type="mini" @click="zoomIn">放大</el-button>
          <el-button type="mini" @click="zoomOut">缩小</el-button>
        </div>
        <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//富文本
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import * as Quill from "quill";
import {
  quillEditor
} from "vue-quill-editor";
import {
  ImageDrop
} from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

//下载
import fileDownload from "js-file-download";

// pdf预览
import pdf from "vue-pdf";

export default {
  components: {
    quillEditor,
    pdf
  },

  data() {
    return {
      //pdf显示
      pdfSrc: '', // PDF 文件的 URL
      pdfVisible: false, // 控制 PDF 弹窗显示
      iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整



      // editContent: '',
      // pid: '',
      userid: "",
      projectCategory: [],
      projcetDistribute: [],

      // infoFormVisible: false,

      // projectInfoPng: [], //课题信息图片
      projectAssess: {}, //评审按钮传入的待评审课题
      //评审对话框
      assessDialogVisible: false,
      //评审评分信息
      assessScore: [{
        name: "1、研究内容与研究目标的一致性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "2、研究路径、方法的科学性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "3、项目的可行性",
        scores: [{
          name: "强",
          score: 5
        },
        {
          name: "较强",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "4、前期的研究成果",
        scores: [{
          name: "高",
          score: 5
        },
        {
          name: "较高",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较低",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "5、项目的团队力量",
        scores: [{
          name: "强",
          score: 5
        },
        {
          name: "较强",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "6、项目时间安排的合理性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "7、经费安排的合理性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      }
      ],
      // 评审建议
      assessSuggestion: "",
      assessFunds: null,
      assessAgree: "",
      password: "",
      assessDate: "",

      //以下为查看申报书相关
      pid: "",
      projectInfo: [], //课题列表
      projectInfoShow: {}, //选中查看的
      // projectCategorys: [],
      // selectValue: "", //课题类型下拉框显示的值
      projectStatus: [],
      status: "",
      projectLeader: [], //主持人，返回的是列表
      leader: {}, //主持人，取列表第一项
      projectMember: [], //本项目参加人
      infoFormVisible: false,
      editForm: {}, //编辑申报书
      auditInfo: {},
      editLeaderVisible: false, //显示编辑主持人对话框
      fileList: [], //附件列表
      infoDialogVisible: false, //对话框
      projectInfoPng: [], //课题信息图片
      projectInfoPngIsNull: true, //图片是否为空，显示“请等待详情页面加载……”
      budget: {},
      // qill-editor
      editorOption: {}
    };
  },

  created() {
    this.userid = localStorage.getItem("userid");
    this.username = localStorage.getItem("username");
    this.getProjectCategory();
    // this.getProjectInfoDistribute()
    let d = new Date();
    this.assessDate =
      d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日";

    // 禁止复制粘贴
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    })

  },

  watch: {
    projectInfoShow() {
      this.editForm = this.projectInfoShow;
      this.budget = this.editForm.budget;
      this.getProjectLeader(this.editForm.leader);
    },

    // 2021-11-26 直接查看pdf，不需要查看图片了
    // projectInfoPng() {
    //   // watch中监控projectInfoPng，存在延时。有时点击查看了新的pid，但是延时返回的是旧pid，需要更新
    //   if (this.projectInfoPng.length > 0) {
    //     if (this.projectInfoPng[0].pid != this.pid) {
    //       this.projectInfoPng = [];
    //       this.getProjectInfoPng(this.pid);
    //     }
    //   }

    //   this.infoDialogVisible = !this.infoDialogVisible;
    //   if (this.projectInfoPng.length == 0) {
    //     this.projectInfoPngIsNull = true;
    //   } else {
    //     this.projectInfoPngIsNull = false;
    //   }
    // },

    assessAgree() {
      if (this.assessAgree == '不同意') {
        this.assessFunds = 0
      }
    }
  },

  methods: {
    // 获取课题类型
    async getProjectCategory() {
      const res1 = await this.axios.get(`/projectCategory/?is_active=True`);
      if (res1.status === 200) {
        this.projectCategory = res1.data.results;
        for (let i = 0; i < this.projectCategory.length; i++) {
          // 判断课题方向是否为空
          if (
            this.projectCategory[i].direction == null ||
            this.projectCategory[i].direction.data == null
          ) {
            return this.$message.warning(`课题方向为空，请先添加课题方向！`);
          }
          //
          let category = this.projectCategory[i];
          for (let j = 0; j < category.direction.data.length; j++) {
            let url =
              `projectDistribute/?status=评审&assessor=${this.userid}&category_direction=${category.direction.data[j].name}`;
            let resInfo = await this.axios.get(url);
            if (resInfo.status == 200) {
              this.projcetDistribute.push({
                category: category.name,
                direction: category.direction.data[j].name,
                data: resInfo.data.results
              });
            }
          }
        }
      } else {
        this.$message.warning("获取类型错误");
      }
    },

    // 获取课题信息
    // async getProjectInfoDistribute() {
    //   const res = await this.axios.get(`/projectDistribute/?assessor=${this.userid}`)
    //   if (res.status === 200) {
    //     this.projcetDistribute = res.data.results
    //   } else {
    //     this.$message.warning("错误")
    //   }
    // },

    //评审按钮
    async assessButton(item) {
      this.assessDialogVisible = !this.assessDialogVisible;
      // this.assessDialogVisible = true;
      this.projectAssess = '';
      this.projectAssess = item;

      // 清空评审对话框
      this.assessScore = [{
        name: "1、研究内容与研究目标的一致性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "2、研究路径、方法的科学性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "3、项目的可行性",
        scores: [{
          name: "强",
          score: 5
        },
        {
          name: "较强",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "4、前期的研究成果",
        scores: [{
          name: "高",
          score: 5
        },
        {
          name: "较高",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较低",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "5、项目的团队力量",
        scores: [{
          name: "强",
          score: 5
        },
        {
          name: "较强",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "6、项目时间安排的合理性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      },
      {
        name: "7、经费安排的合理性",
        scores: [{
          name: "很好",
          score: 5
        },
        {
          name: "较好",
          score: 3
        },
        {
          name: "一般",
          score: 2
        },
        {
          name: "较差",
          score: 1
        }
        ],
        score: 0
      }
      ]
      this.assessSuggestion = " "
      this.assessFunds = null
      this.assessAgree = ""
      // 先查询是否有保存记录
      let res = await this.axios.get('/projectAssessTemp/?pid=' + this.projectAssess.pid + '&assessor=' + this.userid)
      if (res.data.results.length > 0) {
        // console.log('save result:', res.data.results[0])
        let data = res.data.results[0].assessor_result
        this.assessScore = data.assessScore
        this.assessSuggestion = data.assessSuggestion
        this.assessFunds = data.assessFunds
        this.assessAgree = data.assessAgree
      }

      // let res = await this.axios.get(`/user/?userid=${item.leader}`);
      // if (res.status === 200) {
      //   this.projectAssess.organization = res.data.results[0].organization;
      //   this.$forceUpdate();
      // } else {
      //   this.$message.warning("获取专家错误");
      // }
    },

    // 保存评审结果
    async save() {
      // 先查询是否有记录
      let res = await this.axios.get('/projectAssessTemp/?pid=' + this.projectAssess.pid + '&assessor=' + this.userid)
      if (res.data.results.length > 0) {
        // 删除原有记录
        // console.log("删除记录：", this.userid, res.data.results)
        // return
        let resDel = await this.axios.delete('/projectAssessTemp/' + res.data.results[0].id)
        // 如果返回删除成功
        if (resDel.status == 204) {
          this.$message.success('原保存记录已删除！')
        } else {
          return this.$message.error('原保存记录删除失败！请重新提交！')
        }
      }
      // 写projectMiddleCheckTemp评审结果表        
      let data = {
        pid: this.projectAssess.pid,
        pname: this.projectAssess.pname,
        leader: this.projectAssess.leader,
        leader_name: this.projectAssess.leader_name,
        category: this.projectAssess.category,
        category_direction: this.projectAssess.category_direction,
        assess_date: this.assessDate,
        status: '已评审',
        assessor: this.userid,
        assessor_name: this.username,
        assessor_result: {
          assessSuggestion: this.assessSuggestion,
          assessScore: this.assessScore,
          assessFunds: this.assessFunds,
          assessAgree: this.assessAgree
        },
        // new_pid: this.projectAssess.new_pid,
        // new_name: this.projectAssess.new_name
      }
      let resPost = await this.axios.post('/projectAssessTemp/', data)
      // 新增成功，提示
      if (resPost.status == 201) {
        this.$message.success('保存成功！')
      } else {
        this.$message.error('保存失败！请稍后再试！')
      }
    },

    // 计算评审结果
    async assess() {
      if (!this.assessAgree) {
        return this.$message.error("请选择同意或不同意！");
      } else if (this.assessAgree == "同意") {
        // 同意时，经费不能为空
        if (!this.assessFunds) {
          return this.$message.error("建议的经费不能为空！");
        }
        // 如果有汉字，转换
        this.assessFunds = parseFloat(this.assessFunds)
      }
      // 意见不能为空
      if (!this.assessSuggestion) {
        return this.$message.error("专家对项目的意见和建议不能为空！");
      }

      // 验证密码
      let resPass = await this.axios.get(
        "/expertSignPass/?userid=" + this.userid
      );
      // 没有记录，需要先设置密码
      if (resPass.data.results.length == 0) {
        return this.$message.error(
          "您还没有设置签名密码，请先在“专家管理>专家签名密码管理”页面设置密码！"
        );
      } else if (!resPass.data.results[0].png) {
        return this.$message.error(
          "您还没有上传签名，请先在“专家管理>专家签名密码管理”页面上传签名！"
        );
      }
      // 验证密码
      if (this.password != resPass.data.results[0].password) {
        return this.$message.error("请输入正确的签名密码！");
      }
      let score = 0;
      for (let i = 0; i < this.assessScore.length; i++) {
        score = score + this.assessScore[i].score;
      }
      // this.$message.success(`评审总分为：${score}分！`)
      let res = await this.axios.get(
        "/projectAssess/?pid=" + this.projectAssess.pid
      );
      res = res.data.results;

      // 写ProjectAssess评审结果表
      if (res[0]) {
        // 有记录,添加记录的assessor_result
        let data = res[0];
        // 将评审结果添加到数组
        // 如果专家结果为空，先赋值，否则报错
        if (!data.assessor_result) {
          data.assessor_result = { data: [] }
        }

        data.assessor_result.data.push({
          assessor: this.userid,
          aname: this.username,
          assessSuggestion: this.assessSuggestion,
          assessAgree: this.assessAgree,
          assessScore: this.assessScore,
          total_score: score,
          assessFunds: Number(this.assessFunds),
          assessDate: this.assessDate
        });
        let resPut = await this.axios.put(`/projectAssess/${data.id}/`, data);
        // 删除projectDistribute
        let resGet = await this.axios.get(
          "/projectDistribute/?status=评审&pid=" +
          this.projectAssess.pid +
          "&assessor=" +
          this.userid
        );
        resGet = resGet.data.results[0];
        let resDel = await this.axios.delete(`/projectDistribute/${resGet.id}`);
        // console.log('del1:' + resDel.status)
        if (resPut.status == 200) {
          this.$message.success("评审完成");
        } else {
          this.$message.error("评审失败");
        }
      } else {
        // 无记录，post
        let data = {
          pid: this.projectAssess.pid,
          pname: this.projectAssess.pname,
          leader: this.projectAssess.leader,
          leader_name: this.projectAssess.leader_name,
          category: this.projectAssess.category,
          category_direction: this.projectAssess.category_direction,
          status: "未立项",
          assessor_result: {
            data: [{
              assessor: this.userid,
              aname: this.username,
              assessSuggestion: this.assessSuggestion,
              assessAgree: this.assessAgree,
              assessScore: this.assessScore,
              total_score: score,
              assessFunds: Number(this.assessFunds),
              assessDate: this.assessDate
            }]
          }
        };
        let resPost = await this.axios.post("/projectAssess/", data);
        // 删除projectDistribute
        let resGet = await this.axios.get(
          "/projectDistribute/?status=评审&pid=" +
          this.projectAssess.pid +
          "&assessor=" +
          this.userid
        );
        resGet = resGet.data.results[0];
        let resDel = await this.axios.delete(`/projectDistribute/${resGet.id}`);
        // console.log('del:' + resDel.status)
        if (resPost.status == 201) {
          this.$message.success("评审成功！");
        } else {
          this.$message.error("评审失败");
        }
      }
      // 对话框不可见，初始化课题列表
      this.assessDialogVisible = false;
      // this.getProjectInfoDistribute()
      setTimeout(() => {
        location.reload();
      }, 500);
    },

    // 以下为查看信息相关函数

    // 获取课题信息
    async getProjectInfo(pid) {
      const res = await this.axios.get(`/projectInfo/?pid=${pid}`);
      if (res.status === 200) {
        // console.log('info', res.data.results)
        this.projectInfoShow = res.data.results[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询课题信息
    async queryProjectInfo() {
      // const res = await this.axios.get(`/projectInfoLite/?search=${this.query}`)
      const res = await this.axios.get(
        `/projectInfoLite/?search=${this.query}`
      );
      if (res.status === 200) {
        this.projectInfo = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      const res = await this.axios.get(`/fileList/?pid=${pid}`);
      if (res.status === 200) {
        this.fileList = res.data.results;
      } else {
        this.$message.warning("获取文件列表错误");
      }
    },

    // 查询主持人信息
    async getProjectLeader(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        this.projectLeader = res.data.results;
        this.leader = this.projectLeader[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取username
    async getUserName(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        return this.projectLeader[0].username;
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询参加者
    async getProjectMember(id) {
      const res = await this.axios.get(`/projectMember/?pid=${id}`);
      if (res.status === 200) {
        this.projectMember = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    //获取状态名称
    statusName(id) {
      name = "";
      this.projectStatus.forEach(s => {
        if (s.s_id == id) {
          name = s.status;
        }
      });
      return name;
    },

    // // 获取类别名称
    // categoryName(id) {
    //   const item = this.projectCategorys.find((item) => item.id == id);
    //   return item ? item.name : null;
    // },

    // 获取课题图片，供管理员查看
    // async getProjectInfoPng(pid) {
    //   const res = await this.axios.get("/projectInfoPng/?pid=" + pid);
    //   this.projectInfoPng = res.data.results;
    //   // console.log('png', this.projectInfoPng)
    // },

    // 显示查看申报书卡片
    showInfoForm(item) {
      this.infoFormVisible = true;
      this.pid = item.pid; //查看图片、下载原文件用
      this.getProjectInfo(item.pid);
      this.editForm = this.projectInfoShow;
      // console.log('editForm', this.editForm)

      // this.selectValue = this.categoryName(this.editForm.category); //讲id转换成文字
      this.getProjectMember(item.pid);
      this.getFileList(item.pid);
      this.auditInfo = {};
      // this.getAuditInfo(item.pid);
      this.getProjectLeader(this.editForm.leader);

      // 课题信息对话框
      // this.infoDialogVisible = true
      // this.projectInfoPng = [];
      // this.getProjectInfoPng(item.pid);

      setTimeout(() => {
        document.getElementById("id-el-card-info").scrollIntoView({
          behavior: "smooth"
        });
      }, 500);
    },

    // 按钮 查看图片
    // ButtonShowPng() {
    //   this.infoDialogVisible = true;
    // },
    ButtonDownOriginFile() {
      let name = "课题申请书" + this.pid + ".pdf";
      let path = "./toPdf/pdf_temp/" + name;
      let item = {
        path: path,
        name: name
      };
      this.downloadFile(item);
    },

    // 隐藏课题对话框
    infoDialogHide() {
      this.infoDialogVisible = false;
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer"
        })
        .then(res => {
          fileDownload(res.data, item.name);
        });
    },

    // 删除文件
    async deleteFile(item) {
      let res = await this.axios.delete("/fileList/" + item.id + "/");
      if (res.status === 204) {
        this.getFileList(item.pid);
      }
      let data = {
        path: item.path
      };
      let resDelete = await this.axios.post("/deleteFile/", data);
      // console.log(resDelete)
    },

    // pdf预览
    // 获取 PDF 文件
    getPdfCode(item) {
      this.pdfVisible = true;  // 显示弹窗
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };

      this.axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 设置响应的数据类型为 Blob
      }).then(response => {
        // 检查是否为 PDF 文件
        const file = response.data;
        const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
        this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
      }).catch(error => {
        console.error("加载 PDF 文件失败:", error);
      });
    },

    // 将 Blob 转换为 URL
    createPdfObjectURL(file) {
      return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
    },
    // 放大 PDF
    zoomIn() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
    },
    // 缩小 PDF
    zoomOut() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
    },

    closeCard() {
      this.assessDialogVisible = false
    },
  }
};

</script>

<style lang="less" scoped>
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;
  width: 790px;
}

.ql-editor {
  min-height: 200px;
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;
}

.el-dialog {
  width: 900px;

  .divScore {
    font-size: 20px;
  }

  .el-radio {
    margin-left: 20px;
    width: 70px;
  }

  .divSuggestion {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .divAgree {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .el-button {
    margin-top: 30px;
  }
}

.card-assess {
  position: fixed;
  top: 0;
  left: 1150px;
  height: 800px;
  width: 700px;
  overflow-y: auto;
  overflow: auto;
  z-index: 2;

  .divScore {
    font-size: 20px;
  }

  .el-radio {
    margin-left: 20px;
    width: 70px;
  }

  .divSuggestion {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .divAgree {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .el-button {
    margin-top: 30px;
  }

  .div-budget {
    justify-content: start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectAssess.vue